import EditAutomationAudioSelection from './EditAutomationAudioSelectionContainer';

export { default as EditAutomationAudioSelectionTypeModal } from './EditAutomationAudioSelectionTypeModal';

export default EditAutomationAudioSelection;
